import script from "./HealthSuitePanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./HealthSuitePanel.vue?vue&type=script&lang=ts&setup=true"

import "./HealthSuitePanel.vue?vue&type=style&index=0&id=9b11b58c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b11b58c"]])

export default __exports__